import { render, staticRenderFns } from "./ExLoader.vue?vue&type=template&id=5cd0e78c&scoped=true"
import script from "./ExLoader.vue?vue&type=script&lang=js"
export * from "./ExLoader.vue?vue&type=script&lang=js"
import style0 from "./ExLoader.vue?vue&type=style&index=0&id=5cd0e78c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd0e78c",
  null
  
)

export default component.exports